/**
 * Slider modules
 */
export * from './slider';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/slider/index.js
// module id = 1883
// module chunks = 0